import React, { createContext, useContext } from "react";
import type { PublicConfig } from "../config";

const Ctx = createContext<PublicConfig | null>(null);

export function PublicConfigProvider({
  value,
  children,
}: {
  value: PublicConfig;
  children: React.ReactNode;
}) {
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function usePublicConfig(): PublicConfig {
  const v = useContext(Ctx);
  if (!v) throw new Error("usePublicConfig must be used inside PublicConfigProvider");
  return v;
}
